import React from "react";

interface FeaturesProps {
    featureTitle: any,
    featuresList:any
}

const Features: React.FC<FeaturesProps> = ({ featureTitle, featuresList }) => {
  

  return (
      <React.Fragment>
          <section className="subscription-section">
            <div className="subscription-section__heading">
              <span>Built for contractors</span>
              <h2>{featureTitle} that keep work moving</h2>
              <p>Everything you need from first draft to final payment.</p>
            </div>
            <div className="subscription-feature-grid">
              {featuresList.length && featuresList.map((item: any, index: number) => (
                <article className="subscription-feature" key={`${item.feature}-${index}`}>
                  <span className="subscription-feature__icon"><img src={item.icon} alt="" /></span>
                  <strong>{item.feature}</strong>
                </article>
              ))}
            </div>
          </section>
       
    </React.Fragment>
  );
};

export default Features;
